module.exports = __webpack_public_path__ + "static/media/img-rental.76e4f7f4.jpg";